@if (hasLabel()) {
  <label [for]="inputId" class="FieldLabel">{{ label() }}</label>
}

<!-- Phone prefix and phone number-->
<p-inputGroup>
  @if (!canSelectCountryCode()) {
    <p-inputGroupAddon>
      {{ phonePrefix }}
    </p-inputGroupAddon>
  } @else {
    <p-select
      #dropdown
      [inputId]="countryCodeDropdownId"
      [disabled]="disabled()"
      class="countrycode-selector"
      [style]="{ borderRadius: '3px 0 0 3px' }"
      [options]="countryCodes"
      [filter]="countryCodes.length > 5"
      [ariaLabel]="'accessibility.PhoneCountryCode' | translate"
      [tabindex]="focusable() ? 0 : -1"
      [(ngModel)]="selectedCountryItem"
      [ngModelOptions]="{ standalone: true }"
      [overlayOptions]="countryCodeOverlayOptions"
      optionLabel="label"
      selectedItemTemplate="selectedItem"
      (onFocus)="announcer.announce('+' + selectedCountryItem().value)"
      (onChange)="onCountryCodeChanged()"
      (keydown)="onCountryCodeKeyDown($any($event))"
    >
      <ng-template let-option #item>
        <div class="option-container" [class.has-separator]="countryCodes.length > 5 && option.icon === 'FI'" [attr.data-phone-code]="option.value">
          <div class="flag-option max-h-1rem">
            <img class="flag-icon mr-2" [src]="'/StaticFiles/images/flagpedia/' + option.icon + '.png'" [attr.alt]="option.label" />
            <span aria-hidden="true">{{ option.title }}</span>
          </div>
          <span aria-hidden="true" class="right-aligned">+{{ option.value }}</span>
        </div>
      </ng-template>

      <ng-template #selectedItem>
        <div class="option-container">
          <div class="flag-option max-h-1rem">
            <img class="flag-icon mr-2" [src]="'/StaticFiles/images/flagpedia/' + selectedCountryItem().icon + '.png'" [alt]="selectedCountryItem().label" />
            <span class="selected-country-label">+{{ selectedCountryItem().value }}</span>
          </div>
        </div>
      </ng-template>
    </p-select>
  }

  <input
    #input
    pInputText
    autocomplete="tel-national"
    data-uitest="phone-input"
    [id]="inputId"
    class="w-12"
    [class.border-noround]="canSelectPhoneType && canSelectCountryCode"
    [tabindex]="focusable() ? 0 : -1"
    [ariaLabel]="(isLandLine() ? 'shared.LandlineNumber' : 'shared.MobileNumber') | translate"
    [attr.aria-invalid]="controlRef?.invalid"
    [class.ng-invalid]="controlRef?.errors && controlRef?.dirty"
    [disabled]="disabled()"
    [placeholder]="(isLandLine() ? 'shared.EnterLandline' : 'shared.EnterMobileNumber') | translate"
    [(ngModel)]="inputValue"
    (focus)="hasFocus.set(true)"
    (blur)="hasFocus.set(false); onTouched()"
    (ngModelChange)="onChange(input.value)"
  />

  @if (canSelectPhoneType()) {
    <p-select
      class="mt-auto"
      styleClass="border-noround border-round-right phone-type-selector border-left-none"
      [(ngModel)]="selectedPhoneType"
      [showClear]="false"
      [disabled]="disabled()"
      [options]="phoneNumberTypes"
      (onChange)="updatePhoneType()"
    />
  }
</p-inputGroup>

@if (controlRef?.errors && controlRef?.touched && controlRef?.dirty) {
  <!-- Errors (remember to set the validators on the FormControl instance) -->
  <div role="alert" aria-atomic="true">
    @if (controlRef.errors.required) {
      <p class="field-error" translate>errorMessages.MustBeFilled</p>
    }

    @if (!phoneLengthIsMinimum() && controlRef.errors.phoneLength) {
      <!-- Use phoneLengthValidator here from custom validators -->
      <p class="field-error" [translateParams]="{ length: phoneLength() }" translate>errorMessages.PhoneMustBeXLong</p>
    }

    @if (controlRef.errors.phoneMin) {
      <p class="field-error" [translateParams]="{ length: phoneLength() }" translate>errorMessages.PhoneMustBeMinXLong</p>
    }

    @if (controlRef.errors.phoneMax) {
      <p class="field-error" [translateParams]="{ length: phoneMaxLength() }" translate>errorMessages.MaxXDigits</p>
    }

    @if (controlRef.errors.digitsOnly) {
      <p class="field-error" translate>errorMessages.OnlyDigits</p>
    }
  </div>
}
